import type { Observable } from 'rxjs';

export const BLOB_LOCAL_STORAGE_UNAVAILABLE_ERROR_CODE =
  'local-storage-unavailable';

export type BlobErrorCode =
  | typeof BLOB_LOCAL_STORAGE_UNAVAILABLE_ERROR_CODE
  | (string & {});

export interface BlobState {
  uploading: boolean;
  downloading: boolean;
  errorMessage?: string | null;
  errorCode?: BlobErrorCode | null;
  overSize: boolean;
  needUpload: boolean;
  needDownload: boolean;
}

export interface BlobMetadata {
  mime: string;
  size: number;
}

export interface BlobSource {
  name: string;
  readonly: boolean;
  get: (key: string) => Promise<Blob | null>;
  /** Read MIME and size without downloading the blob bytes. */
  getMetadata?: (key: string) => Promise<BlobMetadata | null>;
  set: (key: string, value: Blob) => Promise<string>;
  delete: (key: string) => Promise<void>;
  list: () => Promise<string[]>;
  // This state is only available when uploading to the server or downloading from the server.
  blobState$?: (key: string) => Observable<BlobState> | null;
  // Re-upload to the server.
  upload?: (key: string) => Promise<boolean>;
}
